import type React from "react";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router";
import { OpenNewTabIcon } from "~/components/icons";
import { config } from "~/config";
import { useSession } from "~/ory";

export const MenuButton: React.FC = () => {
	const [session] = useSession();
	const [menuStatus, setMenuStatus] = useState("init");
	const open = useCallback(() => setMenuStatus("open"), []);
	const close = useCallback(() => setMenuStatus("close"), []);

	const escFunction = useCallback(
		(event: KeyboardEvent) => {
			if (menuStatus === "open" && event.key === "Escape") {
				close();
			}
		},
		[menuStatus, close],
	);
	useEffect(() => {
		document.addEventListener("keydown", escFunction, false);
		return () => {
			document.removeEventListener("keydown", escFunction, false);
		};
	}, [escFunction]);

	return (
		<div>
			<button type="button" onClick={open}>
				<img
					className="header-menu-open-btn"
					src="/images/menu-open.png"
					alt="Open Menu"
				/>
			</button>
			{/* biome-ignore lint/a11y/noStaticElementInteractions: overlay click-to-close is a UX enhancement; keyboard close handled by Escape key */}
			<div
				className={`t4-menu-wrapper ${menuStatus}`}
				role="presentation"
				onClick={(e) => {
					if (e.target === e.currentTarget) close();
				}}
			>
				<section className="t4-menu flex flex-col">
					<div className="header-menu-close-btn-wrapper">
						<button type="button" onClick={close}>
							<img
								className="header-menu-close-btn"
								src="/images/menu-close.png"
								alt="Close Menu"
							/>
						</button>
					</div>
					<nav className="menu-main-navigation px-10 md:px-16 mt-8 grow">
						{!!session && (
							<Link to="/settings" onClick={close}>
								ACCOUNT SETTINGS
							</Link>
						)}
						<a
							href={config.tierivPortalUrl}
							target="_blank"
							rel="noopener noreferrer"
						>
							TIER IV PORTAL <OpenNewTabIcon color="white" />
						</a>
						<a
							href="https://docs.web.auto/user-manuals/tier-iv-account/introduction"
							target="_blank"
							rel="noopener noreferrer"
						>
							<span>DOCUMENTATION</span> <OpenNewTabIcon color="white" />
						</a>
					</nav>
					<footer className="p-10 md:p-16 footer text-neutral-content">
						<div>
							<a
								href="https://tier4.jp/"
								target="_blank"
								rel="noopener noreferrer"
							>
								TIER IV
							</a>
							<a
								href="https://web.auto/"
								target="_blank"
								rel="noopener noreferrer"
							>
								Web.Auto
							</a>
							<a
								href="https://pilot.auto/"
								target="_blank"
								rel="noopener noreferrer"
							>
								Pilot.Auto
							</a>
							<a
								href="https://docs.web.auto/"
								target="_blank"
								rel="noopener noreferrer"
							>
								Web.Auto Docs
							</a>
							<a
								href="https://docs.pilot.auto/"
								target="_blank"
								rel="noopener noreferrer"
							>
								Pilot.Auto Docs
							</a>
							<a
								href="https://www.autoware.org/"
								target="_blank"
								rel="noopener noreferrer"
							>
								AUTOWARE
							</a>
						</div>
						<div>
							<a
								href="https://careers.tier4.jp/"
								target="_blank"
								rel="noopener noreferrer"
							>
								CAREERS
							</a>
							<a
								href="https://tier4.jp/media/"
								target="_blank"
								rel="noopener noreferrer"
							>
								MEDIA
							</a>
						</div>
					</footer>
				</section>
			</div>
		</div>
	);
};
